import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_firmware_dialog = _resolveComponent("firmware-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_list_pagination, {
      headers: _ctx.headers,
      showCheck: false,
      showDefaultAction: ['info'],
      requestData: _ctx.requestData,
      onInfo: _ctx.showFirmWareDetail
    }, {
      LogSlot: _withCtx((data) => [
        _createVNode("span", null, _toDisplayString(data.scope.Log[0]), 1)
      ]),
      _: 1
    }, 8, ["headers", "requestData", "onInfo"]),
    (_ctx.showDetail)
      ? (_openBlock(), _createBlock(_component_firmware_dialog, {
          key: 0,
          initForm: _ctx.initForm,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetail=false))
        }, null, 8, ["initForm"]))
      : _createCommentVNode("", true)
  ]))
}